import React from 'react';

const Footer = () => {
    return (
        <footer>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-12">
                        <p>This website and the acquisition information in this site does not constitute either (i) an offer to purchase a center or any related assets; or (ii) an offer of employees of a potential seller. This website is an advertisement which presents a potential opportunity for the possible sale of a service center to Jiffy Lube and should in no way be construed as an assurance that Jiffy Lube will either make an offer for, or purchase, a potential seller’s service center.</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-6">
                        <ul className="list-inline">
                            <li className="list-inline-item">
                                <a href="https://www.jiffylube.com/" target="_blank">JiffyLube.com</a>
                            </li>
                            <li className="list-inline-item">
                                <a href="https://www.linkedin.com/company/jiffy-lube-international/" target="_blank">LinkedIn</a>
                            </li>
                            <li className="list-inline-item">
                                <a href="https://www.jiffylube.com/privacy-policy" target="_blank">Privacy Policy</a>
                            </li>
                            <li className="list-inline-item">
                                <a href="https://franchise.jiffylube.com/home/termsofuse">Terms of Use</a>
                            </li>
                            <li className="list-inline-item">
                                <a href="https://www.jiffylube.com/accessibility-statement" target="">Accessibility Statement</a>
                            </li>
                        </ul>
                    </div>
                    <div className="col-lg-6 disclaimer">
                        <p>&copy; {(new Date().getFullYear())} Jiffy Lube International, Inc</p>
                    </div>
                </div>
            </div>
    </footer>
    )
}

export default Footer;